import React from "react";

import * as AdminBannerStyles from "./styles/adminBanner";

function AdminBanner() {
	return <div style={AdminBannerStyles.banner}>You are signed in the Administrator side of the site. The login from will be disabled this end.</div>;
}

export default AdminBanner;
